import React, { ReactElement } from 'react'
import {
  Box,
  BoxProps,
  Flex,
  Icon,
  IconType,
  Text,
} from '@mindfulchefuk/design-system'
import { css } from 'styled-system/css'
import { bleed } from 'styled-system/patterns'
import { CMSBanner } from '@mindfulchefuk/features/CMS/interfaces'
import { OnboardingChooseRecipesBannerImage } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesBanner/OnboardingChooseRecipesBannerImage/OnboardingChooseRecipesBannerImage'

type TBannerCallout = {
  icon: IconType
  id: string
  copy: string
} & BoxProps

const BannerCallout = ({ icon, id, copy, ...props }: TBannerCallout) => {
  return (
    <Flex id={id} {...props}>
      <Icon
        type={icon}
        color="aubergine"
        size={{ base: 24, md: 28 }}
        flexShrink={0}
      />

      <Text
        variant={{ base: 'body-sm', md: 'body-lg' }}
        color="pepper"
        ml={{ base: 8, md: 16 }}
        id={`${id}-copy`}
      >
        {copy}
      </Text>
    </Flex>
  )
}

export type TOnboardingChooseRecipesBanner = {
  banner: CMSBanner | null
}

export const OnboardingChooseRecipesBanner = ({
  banner,
}: TOnboardingChooseRecipesBanner): ReactElement => (
  <div
    className={bleed({
      inline: { base: 14, lg: 0 },
      display: 'flex',
      flexDirection: { base: 'column', lg: 'row' },
    })}
    id="choose-recipes-header"
  >
    <Box>
      <OnboardingChooseRecipesBannerImage banner={banner} />
    </Box>
    <div
      className={css({
        background: 'salt',
        justifyContent: 'center',
        py: { base: 4, lg: 6 },
        px: { base: 6, sm: 4, lg: 6 },
        width: { base: '100%', lg: '50%' },
      })}
    >
      <BannerCallout
        id="choose-recipes-text-protein"
        icon="heart"
        copy="Delicious, high quality protein - and lots of it"
      />
      <BannerCallout
        id="choose-recipes-text-refined-carbs"
        icon="gluten-free"
        copy="No stodgy refined carbs - no carb comas here"
        my={{ base: 12, lg: 36 }}
      />
      <BannerCallout
        id="choose-recipes-text-fibre"
        icon="soil"
        copy="Goodness from natural food. Plenty of veg - full of fibre"
      />
    </div>
  </div>
)
